import { dashboardLeadsTypes } from "../../types";
const initialState = {
    data: [],
    loading: false,
    error: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case dashboardLeadsTypes.FETCH:
            return { ...state, loading: true }
        case dashboardLeadsTypes.SUCCESS:
            return { ...state, data: payload, loading: false, error: "", }
        case dashboardLeadsTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case dashboardLeadsTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;